
interface BrandStoryProps {
  data: {
    description: string;
    points: { title: string; desc: string }[];
  };
}
// brandStory = '헤리츠테일러는 전통을 이어온 마스터 테일러의 명품 장인 정신과 트렌디한 감각이 공존하는 프리미엄 맞춤 예복 전문 브랜드입니다.\n\n엄선된 최고급 원단과 40년 경력 장인의 정교한 테일러링을 통해 고객님의 가장 빛나는 순간을 완성합니다. 프라이빗한 공간에서 제안하는 1:1 맞춤 스타일링과 체계적인 웨딩 패키지로 생애 최고의 만족을 경험해 보세요. \n당신의 가치와 품격을 담은 단 하나의 수트, 헤리츠테일러가 함께합니다.',
// brandStoryPoints = [
//   {
//     title: '다양한 원단 보유',
//     description: '취향에 맞는 정품 원단 직접 비교',
//   },
//   {
//     title: '합리적인 견적',
//     description: '품질 대비 실속 있는 예복 구성',
//   },
//   {
//     title: '혼주 동반 할인',
//     description: '가족 예복 진행 시 큰 폭의 혜택',
//   },
//   {
//     title: '리폼 서비스',
//     description: '예식 후 평상복으로 활용 가능',
//   },
// ]
export default function BrandStory({ data = {} }: BrandStoryProps) {
  return (
    <div className="">
      <div className="bg-white rounded-2xl p-5 lg:p-6">
        <div className="lg:flex lg:gap-8">
          <div className="lg:flex-1">
            <h2 className="text-lg md:text-xl font-bold text-[#121B35] mb-3">BRAND STORY</h2>
            <p className="text-sm md:text-base text-[#536079] leading-relaxed">
              {data.description?.split('\n').reduce((acc, curr) => {
                acc.push(curr)
                acc.push(<br />)
                return acc
              }, [])}
            </p>
          </div>
          <div className="mt-5 lg:mt-0 lg:w-[220px] shrink-0 space-y-3">
            {data.points?.map((point, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-1 h-1 rounded-full bg-[#B9965B] mt-2 shrink-0" />
                <div>
                  <p className="text-sm md:text-base font-semibold text-[#121B35]">{point.title}</p>
                  <p className="text-xs md:text-sm text-[#536079] mt-0.5">{point.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}